<template>
  <div class="container">
    <div class="forms-container">
      <div class="signin-signup">
        <form action="#" class="sign-in-form">
          <h2 class="title">ورود</h2>
          <div class="input-field">
            <font-awesome-icon class="i" icon="user" />
            <input
              type="text"
              v-model="login.name"
              placeholder="نام کاربری یا شماره همراه"
            />
          </div>
          <div class="input-field">
            <font-awesome-icon class="i" icon="user" />
            <input
              type="password"
              v-model="login.pass"
              placeholder="کلمه عبور"
            />
          </div>
          <router-link
            style="text-decoration: none; color: var(--font-color)"
            to="/user/forgot-password"
            class="forgat_pass"
            >کلمه عبور خود را فراموش کرده اید؟</router-link
          >
          <input
            type="submit"
            value="ورود به فروشگاه شمع خورشید "
            class="btn solid"
            @click.prevent="logIn"
          />
          <!-- <p class="social-text">Or Sign in with social platforms</p>
          <div class="social-media">
            <a href="#" class="social-icon">
              <i class="fab fa-facebook-f"></i>
            </a>
            <a href="#" class="social-icon">
              <i class="fab fa-twitter"></i>
            </a>
            <a href="#" class="social-icon">
              <i class="fab fa-google"></i>
            </a>
            <a href="#" class="social-icon">
              <i class="fab fa-linkedin-in"></i>
            </a>
          </div> -->
        </form>
        <form action="#" class="sign-up-form">
          <h2 class="title">ثبت نام</h2>
          <div class="input-field">
            <font-awesome-icon class="i" icon="user" />
            <input type="text" v-model="signup.fname" placeholder="نام" />
          </div>
          <div class="input-field">
            <font-awesome-icon class="i" icon="user" />
            <input
              type="text"
              v-model="signup.lname"
              placeholder="نام خانوادگی"
            />
          </div>
          <div class="input-field">
            <font-awesome-icon class="i" icon="user" />
            <input
              type="email"
              v-model="signup.email"
              placeholder=" ایمیل (اختیاری) "
            />
          </div>
          <div class="input-field">
            <font-awesome-icon class="i" icon="user" />
            <input
              type="tel"
              @keydown="cheeee"
              v-model="signup.phoo"
              placeholder="تلفن همراه"
            />
          </div>
          <div class="input-field">
            <font-awesome-icon class="i" icon="user" />
            <input
              type="password"
              v-model="signup.pass"
              placeholder="رمز عبور"
            />
          </div>
          <div class="input-field">
            <font-awesome-icon class="i" icon="user" />
            <input
              type="password"
              v-model="signup.c_pass"
              placeholder="تکرار رمز عبور"
            />
          </div>
          <input
            @click.prevent="signUp"
            type="submit"
            class="btn cccsss"
            value="ثبت نام در فروشگاه شمع خورشید"
          />

          <!-- <p class="social-text">Or Sign up with social platforms</p>
          <div class="social-media">
            <a href="#" class="social-icon">
              <i class="fab fa-facebook-f"></i>
            </a>
            <a href="#" class="social-icon">
              <i class="fab fa-twitter"></i>
            </a>
            <a href="#" class="social-icon">
              <i class="fab fa-google"></i>
            </a>
            <a href="#" class="social-icon">
              <i class="fab fa-linkedin-in"></i>
            </a>
          </div> -->
        </form>
      </div>
    </div>

    <div class="panels-container">
      <div class="panel left-panel">
        <div class="content">
          <h3>هنوز ثبت نام نکرده اید؟</h3>
          <p>
            <!-- به کیفیت اجناس ما اطمینان کنید. -->
            با عضویت در فروشگاه شمع خورشید از ارسال کالای خود اطلاع کسب کنید.
          </p>
          <button class="btn transparent" id="sign-up-btn">ثبت نام</button>
        </div>
        <!-- <img src="img/log.svg" class="image" alt="" /> -->
      </div>
      <div class="panel right-panel">
        <div class="content">
          <h3>ورود به پنل شخصی شمع خورشید</h3>
          <p>
            با ورود به پنل شمع خورشید لیست خرید ها و فاکتور های خود را مشاهده
            کنید.
          </p>
          <button class="btn transparent" id="sign-in-btn">ورود</button>
        </div>
        <!-- <img src="img/register.svg" class="image" alt="" /> -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      signup: {
        phoo: "",
        fname: "",
        lname: "",
        email: "",
        pass: "",
        c_pass: "",
      },
      login: {
        name: "",
        pass: "",
      },
    };
  },
  created() {
    // this.$toastr.i("لطفا نام کاربری  را به انگلیسی وارد کنید");
    String.prototype.toPersianDigits = function () {
      var id = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
      return this.replace(/[0-9]/g, function (w) {
        return id[+w];
      });
    };
    this.$store.state.load = false;
  },
  methods: {
    cheeee(e) {},
    logIn(e) {
      var that = this;
      that.$store.state.load = true;

      this.login.name = this.login.name
        .replace(/[٠-٩]/g, (d) => "٠١٢٣٤٥٦٧٨٩".indexOf(d))
        .replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));

      if (this.login.pass.length == 0 || this.login.name.length == 0) {
        that.$toastr.e("لطفا تمام فیلد ها را پر کنید");
        that.$store.state.load = false;
      } else {
        $.ajax({
          url: that.$store.state.url + "api/v1/accounts/login/",
          crossDomain: true,
          xhrFields: {
            withCredentials: true,
          },
          data: {
            eu: this.login.name,
            password: this.login.pass,
          },
          type: "POST",
          success: function (data, textStatus, request) {
            localStorage.setItem("profile", data.access_d.value);
            localStorage.setItem("ex", data.access_d.expires);
            that.$toastr.s(data.msg);
            that.$store.state.user.name = data.name;
            localStorage.setItem("name", data.name);
            that.$store.state.user.name = data.name;
            that.$store.state.name = data.name;

            $.ajax({
              url: that.$store.state.url + "api/v1/pages/nav/",
              crossDomain: true,
              xhrFields: {
                withCredentials: true,
              },
              headers: {
                Authorization: "Bearer" + " " + localStorage.getItem("profile"),
              },
              type: "GET",
              success: function (data, textStatus, request) {
                that.logo = data.logo;
                that.$router.go(-1);

                if (data.cart_count) {
                  that.$store.state.co = data.cart_count;
                }
              },
              error: function (request, textStatus, errorThrown) {
                if (request.state == 500) {
                  that.$toastr.e("خطایی در سرور به وجود امده");
                  that.$store.state.e500 = true;
                } else {
                  that.$store.state.e404 = true;
                  that.$toastr.e("خطا در برقراری ارتباط");
                }
              },
              complete: function () {},
            });
          },
          error: function (request, textStatus, errorThrown) {
            that.$toastr.e(request.responseJSON);
          },
          complete: function () {
            that.$store.state.load = false;
          },
        });
      }
    },
    signUp(e) {
      function validateEmail(email) {
        const re =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
      }

      this.signup.phoo = this.signup.phoo
        .replace(/[٠-٩]/g, (d) => "٠١٢٣٤٥٦٧٨٩".indexOf(d))
        .replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));

      this.signup.pass = this.signup.pass
        .replace(/[٠-٩]/g, (d) => "٠١٢٣٤٥٦٧٨٩".indexOf(d))
        .replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));

      this.signup.c_pass = this.signup.c_pass
        .replace(/[٠-٩]/g, (d) => "٠١٢٣٤٥٦٧٨٩".indexOf(d))
        .replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));
      // alert(this.signup.phoo);

      var that = this;
      that.$store.state.load = true;
      if (
        this.signup.fname.length == 0 ||
        this.signup.lname.length == 0 ||
        this.signup.phoo.length == 0 ||
        this.signup.pass.length == 0 ||
        this.signup.c_pass.length == 0
      ) {
        that.$toastr.e("لطفا تمام فیلد ها را پر کنید.");
        that.$store.state.load = false;
      } else if (this.signup.fname.length >= 30) {
        that.$toastr.e("طول نام شما بیشتر از حد مجاز است.");
        that.$store.state.load = false;
      } else if (this.signup.fname.length >= 150) {
        that.$toastr.e("طول نام خانوادگی شما بیشتر از حد مجاز است.");
        that.$store.state.load = false;
      } else if (this.signup.phoo.length != 11) {
        that.$toastr.e("لطفا شماره همراه معتبر وارد کنید");
        that.$store.state.load = false;
      } else if (!validateEmail(this.signup.email) && this.signup.email != 0) {
        that.$toastr.e("ایمیل معتبر وارد کنید.");
        that.$store.state.load = false;
      } else if (this.signup.pass.length < 8 || this.signup.c_pass.length < 8) {
        that.$toastr.e("طول رمز های وارد شده باید بیشتر از ۸ رقم باشد.");
        that.$store.state.load = false;
      } else if (this.signup.c_pass != this.signup.pass) {
        that.$toastr.e("رمز وارد شده با تکرار آن یکسان نیست.");
        that.$store.state.load = false;
      } else {
        $.ajax({
          url: that.$store.state.url + "api/v1/accounts/register/",
          crossDomain: true,
          xhrFields: {
            withCredentials: true,
          },
          data: {
            cellphone: this.signup.phoo,
            fname: this.signup.fname,
            lname: this.signup.lname,
            email: this.signup.email,
            password: this.signup.pass,
            password_c: this.signup.c_pass,
          },
          type: "POST",
          success: function (data, textStatus, request) {
            localStorage.setItem("profile", data.access_d.value);
            localStorage.setItem("ex", data.access_d.expires);
            // console.log(localStorage.getItem("profile"));
            // console.log(localStorage.getItem("ex"));
            localStorage.setItem("name", data.name);
            that.$toastr.s(data.msg);
            that.$store.state.user.name = data.name;
            // console.log(that.$store.state.user.name);
            that.$store.state.user.name = data.name;
            // console.log(data.access_d.expires);
            that.$store.state.name = data.name;

            $.ajax({
              url: that.$store.state.url + "api/v1/pages/nav/",
              crossDomain: true,
              xhrFields: {
                withCredentials: true,
              },
              headers: {
                Authorization: "Bearer" + " " + localStorage.getItem("profile"),
              },
              type: "GET",
              success: function (data, textStatus, request) {
                // console.log(data);
                that.logo = data.logo;
                if (data.cart_count) {
                  that.$store.state.co = data.cart_count;
                }
              },
              error: function (request, textStatus, errorThrown) {
                if (request.state == 500) {
                  that.$toastr.e("خطایی در سرور به وجود امده");
                  that.$store.state.e500 = true;
                } else {
                  that.$store.state.e404 = true;
                  that.$toastr.e("خطا در برقراری ارتباط");
                }
              },
              complete: function () {},
            });
            that.$router.push("/");
          },
          error: function (request, textStatus, errorThrown) {
            that.$toastr.e(request.responseJSON);
          },
          complete: function () {
            that.$store.state.load = false;
          },
        });
      }
    },
  },

  mounted() {
    const sign_in_btn = document.querySelector("#sign-in-btn");
    const sign_up_btn = document.querySelector("#sign-up-btn");
    const container = document.querySelector(".container");

    sign_up_btn.addEventListener("click", () => {
      container.classList.add("sign-up-mode");
    });

    sign_in_btn.addEventListener("click", () => {
      container.classList.remove("sign-up-mode");
    });
  },
};
</script>
<style lang="scss" lang="scss" scoped>
.forgat_pass {
  margin: 0.5em;
}
.container {
  position: relative;
  width: 100%;
  background-color: #fff;
  min-height: 100vh;
  overflow: hidden;
  margin-top: 7.9em;
  margin-bottom: -2em;
  font-family: "yekan", "lato";
}

.forms-container {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

.signin-signup {
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  left: 75%;
  width: 50%;
  transition: 1s 0.7s ease-in-out;
  display: grid;
  grid-template-columns: 1fr;
  z-index: 5;
}

form {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 0rem 5rem;
  transition: all 0.2s 0.7s;
  overflow: hidden;
  grid-column: 1 / 2;
  grid-row: 1 / 2;
}

form.sign-up-form {
  opacity: 0;
  z-index: 1;
}

form.sign-in-form {
  z-index: 2;
  margin-top: -5em;
}

.title {
  font-size: 2.2rem;
  color: #444;
  margin-bottom: 10px;
}

.input-field {
  position: relative;
  max-width: 380px;
  width: 100%;
  // background: red;
  margin: 10px 0;
  height: 45px;
  display: grid;
  grid-template-columns: 15% 85%;
  direction: rtl;
  display: flex;
  align-items: center;
  input {
    width: 100%;
    outline: none;
    color: var(--font-color);
    background: var(--bg-color) !important;
    border: none;
    padding: 0.5em;
    padding-right: 2.5em;
    border-radius: 8px;
    //   background: red;
    font-family: "yekan", "lato";
  }
  svg {
    position: absolute;
  }
}

.input-field .i {
  text-align: center;
  line-height: 55px;
  color: var(--sub-color);
  transition: 0.5s;
  font-size: 1em;
  margin-left: 1em;
  margin-right: 1em;
}

.input-field input {
  background: none;
  outline: none;
  border: none;
  line-height: 1;
  // font-weight: 600;
  font-size: 1em;
  color: var(--font-color);
  font-family: "yekan";
}

.input-field input::placeholder {
  color: var(--font-color);
  font-weight: 500;
}

.social-text {
  padding: 0.7rem 0;
  font-size: 1rem;
}

.social-media {
  display: flex;
  justify-content: center;
}

.social-icon {
  height: 46px;
  width: 46px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 0.45rem;
  color: #333;
  border-radius: 50%;
  border: 1px solid #333;
  text-decoration: none;
  font-size: 1.1rem;
  transition: 0.3s;
}

.social-icon:hover {
  color: var(--main-color);
  border-color: var(--main-color);
}

.btn {
  width: 250px;
  background-color: var(--sub-color);
  border: none;
  outline: none;
  height: 49px;
  border-radius: 8px;
  color: #fff;
  text-transform: uppercase;
  font-weight: 600;
  margin: 10px 0;
  cursor: pointer;
  transition: 0.5s;
}

.btn:hover {
  //   background-color: ;
}
.panels-container {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  margin-top: -4em;
}

.container:before {
  content: "";
  position: absolute;
  height: 2000px;
  width: 2000px;
  top: -10%;
  right: 48%;
  transform: translateY(-50%);
  background-image: linear-gradient(
    -45deg,
    var(--sub-color) 0%,
    var(--shrink) 100%
  );
  transition: 1.8s ease-in-out;
  border-radius: 50%;
  z-index: 6;
}

.image {
  width: 100%;
  transition: transform 1.1s ease-in-out;
  transition-delay: 0.4s;
}

.panel {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: space-around;
  text-align: center;
  z-index: 6;
  // margin-top: -5em;
}

.left-panel {
  pointer-events: all;
  padding: 3rem 17% 2rem 12%;
}

.right-panel {
  pointer-events: none;
  padding: 3rem 12% 2rem 17%;
  margin-top: -2em;
  @media (max-width: 870px) {
    // margin-bottom: -3em !important;
    height: 10px;
    // background: red;
    transform: translate(0, 35px);
    // height: 10px;
    // margin-bottom: -20em;
  }
  @media (max-width: 570px) {
    // margin-bottom: -3em !important;
    height: 10px;
    // background: red;
    transform: translate(0, 35px);
    // height: 10px;
    // margin-bottom: -20em;
  }
}

.panel .content {
  color: #fff;
  transition: transform 0.9s ease-in-out;
  transition-delay: 0.6s;
  direction: rtl;
}

.panel h3 {
  font-weight: 600;
  line-height: 1;
  font-size: 1.5rem;
  margin-bottom: 0.5em;
}

.panel p {
  margin-bottom: 1.5em;

  font-size: 0.95rem;
  padding: 0.7rem 0;
}

.btn.transparent {
  margin: 0;
  background: none;
  border: 1px solid #fff;
  width: 130px;
  height: 41px;
  font-weight: 600;
  font-size: 0.8rem;
}
.btn {
  font-family: "yekan";
  border-radius: 8px;
}
.right-panel .image,
.right-panel .content {
  transform: translateX(800px);
}

/* ANIMATION */

.container.sign-up-mode:before {
  transform: translate(100%, -50%);
  right: 52%;
}

.container.sign-up-mode .left-panel .image,
.container.sign-up-mode .left-panel .content {
  transform: translateX(-800px);
}

.container.sign-up-mode .signin-signup {
  left: 25%;
}

.container.sign-up-mode form.sign-up-form {
  opacity: 1;
  z-index: 2;
}

.container.sign-up-mode form.sign-in-form {
  opacity: 0;
  z-index: 1;
}

.container.sign-up-mode .right-panel .image,
.container.sign-up-mode .right-panel .content {
  transform: translateX(0%);
}

.container.sign-up-mode .left-panel {
  pointer-events: none;
}

.container.sign-up-mode .right-panel {
  pointer-events: all;
}

@media (max-width: 870px) {
  .container {
    min-height: 800px;
    height: 100vh;
  }
  .signin-signup {
    width: 100%;
    top: 95%;
    transform: translate(-50%, -100%);
    transition: 1s 0.8s ease-in-out;
  }

  .signin-signup,
  .container.sign-up-mode .signin-signup {
    left: 50%;
  }

  .panels-container {
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 2fr 1fr;
  }

  .panel {
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    padding: 2.5rem 8%;
    grid-column: 1 / 2;
  }

  .right-panel {
    grid-row: 3 / 4;
  }

  .left-panel {
    grid-row: 1 / 2;
  }

  .image {
    width: 200px;
    transition: transform 0.9s ease-in-out;
    transition-delay: 0.6s;
  }

  .panel .content {
    padding-right: 15%;
    transition: transform 0.9s ease-in-out;
    transition-delay: 0.8s;
    margin-top: 4em;
  }

  .panel h3 {
    font-size: 1.2rem;
  }

  .panel p {
    font-size: 0.7rem;
    padding: 0.5rem 0;
  }

  .btn.transparent {
    width: 110px;
    height: 35px;
    font-size: 0.7rem;
  }

  .container:before {
    width: 1500px;
    height: 1500px;
    transform: translateX(-50%);
    left: 30%;
    bottom: 68%;
    right: initial;
    top: initial;
    transition: 2s ease-in-out;
  }

  .container.sign-up-mode:before {
    transform: translate(-50%, 100%);
    bottom: 25%;
    right: initial;
  }

  .container.sign-up-mode .left-panel .image,
  .container.sign-up-mode .left-panel .content {
    transform: translateY(-300px);
  }

  .container.sign-up-mode .right-panel .image,
  .container.sign-up-mode .right-panel .content {
    transform: translateY(75px);
  }

  .right-panel .image,
  .right-panel .content {
    transform: translateY(300px);
  }

  .container.sign-up-mode .signin-signup {
    top: 5%;
    transform: translate(-50%, 0);
  }
}

@media (max-width: 570px) {
  form {
    padding: 0 1.5rem;
  }

  .image {
    display: none;
  }
  .panel .content {
    margin-top: 4em;
    padding: 0.5rem 1rem;
  }
  .container {
    padding: 1.5rem;
  }

  .container:before {
    bottom: 68%;
    left: 50%;
  }

  .container.sign-up-mode:before {
    bottom: 28%;
    left: 50%;
  }
}
.cccsss {
  background: rgb(170, 255, 0) !important;
  color: darkslategrey;
}
.z {
  z-index: 50;
}
</style>



// WEBPACK FOOTER //
// src/components/user/login.vue